const RoyaltyCard = {
  id: "royalty",
  title: "Royalty Card",
  subtitle: "Royalty Card Design and Live Stamp",
  type: "group",
  icon: "heroicons-outline:credit-card",
  children: [
    {
      id: "changelog",
      title: "Notification",
      type: "item",
      icon: "heroicons-outline:megaphone",
      url: "/documentation/changelog",
      badge: {
        title: "xxxx",
        bg: "rgb(236, 12, 142)",
        fg: "#FFFFFF",
      },
    },
    {
      id: "changelog 2",
      title: "QR Scan & Live stamp",
      type: "item",
      icon: "heroicons-outline:qr-code",
      url: "/apps/livestamp/index",
      badge: {
        title: "xxxx",
        bg: "rgb(236, 12, 142)",
        fg: "#FFFFFF",
      },
    },
    // {
    //   id: "apps.scrumboard",
    //   title: "QR Scan & Live stamp",
    //   type: "item",
    //   icon: "heroicons-outline:qr-code",
    //   // url: "/apps/scrumboard",
    //   url: "/apps/livestamp/index",
    //   // translate: "SCRUMBOARD",
    // },
    {
      id: "getting-started",
      title: "Loyalty Card Design",
      type: "collapse",
      icon: "heroicons-outline:credit-card",
      children: [
        {
          id: "introduction-doc",
          title: "Introduction",
          type: "item",
          url: "/documentation/getting-started/introduction",
        },
        {
          id: "git-repository-doc",
          title: "Color, Sharp Design Selection",
          type: "item",
          url: "/documentation/getting-started/git-repository",
        },
        {
          id: "installation-doc",
          title: "Installation",
          type: "item",
          url: "/documentation/getting-started/installation",
        },
      ],
    },
    {
      id: "development",
      title: "Live Stamps 2",
      type: "collapse",
      icon: "heroicons-outline:arrow-trending-up",
      children: [
        {
          id: "development-server-doc",
          title: "QR Scan 33333",
          type: "item",
          url: "/documentation/development/development-server",
        },
        {
          id: "production-doc",
          title: "Accept followers",
          type: "item",
          url: "/documentation/development/production",
        },
        {
          id: "deployment-doc",
          title: "Joins Loyalty Program",
          type: "item",
          url: "/documentation/development/deployment",
        },
        {
          id: "directory-structure-doc",
          title: "Live stamps",
          type: "item",
          url: "/documentation/development/directory-structure",
        },
        {
          id: "api-calls-doc",
          title: "Tutorial",
          type: "item",
          url: "/documentation/development/api-calls",
        },
        // {
        //   id: "fuse-react-code-splitting-doc",
        //   title: "Code Splitting",
        //   type: "item",
        //   url: "/documentation/development/code-splitting",
        // },
        // {
        //   id: "fuse-react-multi-language-doc",
        //   title: "Multi Language",
        //   type: "item",
        //   url: "/documentation/development/multi-language",
        // },
        // {
        //   id: "updating-fuse-react-doc",
        //   title: "Updating Fuse React",
        //   type: "item",
        //   url: "/documentation/development/updating-fuse-react",
        // },
        // {
        //   id: "ts-file-remaming-migration-doc",
        //   title: "Typescript migration: File renaming helpter",
        //   type: "item",
        //   url: "/documentation/development/ts-file-rename-migration",
        // },
        // {
        //   id: "fuse-react-ides-vscode-webstorm-doc",
        //   title: "IDEs (Webstorm, VsCode)",
        //   type: "item",
        //   url: "/documentation/development/ides-vscode-webstorm",
        // },
      ],
    },
    // {
    //   id: "mock-api",
    //   title: "Mock API",
    //   type: "item",
    //   icon: "heroicons-outline:cloud",
    //   url: "/documentation/mock-api",
    // },
    {
      id: "theming",
      title: "Theming",
      type: "collapse",
      icon: "heroicons-outline:chevron-double-down",
      children: [
        {
          id: "theme-schemes-doc",
          title: "Theme Schemes",
          type: "item",
          url: "/documentation/theming/theme-schemes",
        },
        {
          id: "theme-layouts-doc",
          title: "Theme Layouts",
          type: "item",
          url: "/documentation/theming/theme-layouts",
        },
        // {
        //   id: "page-layouts-doc",
        //   title: "Page Layouts",
        //   type: "item",
        //   url: "/documentation/theming/page-layouts",
        // },
        // {
        //   id: "rtl-doc",
        //   title: "RTL Support",
        //   type: "item",
        //   url: "/documentation/theming/rtl-support",
        // },
        {
          id: "changing-default-font-doc",
          title: "Changing Default Font",
          type: "item",
          url: "/documentation/theming/changing-default-font",
        },
      ],
    },

    {
      id: "authentication",
      title: "List of loyalty customers",
      type: "item",
      icon: "heroicons-outline:users",
      // url: "/documentation/authentication",
      url: "/apps/contacts",
    },
  ],
};
export default RoyaltyCard;
